import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userList: [],
  receiptList: [],
  receiptDetail: {},
  userFormList: [],
  userDetail: [],
  totalSalesDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
  receiptTotalSales: [],
  receiptTotalSalesYear: [],
  receiptTotalSalesOnline: [],
  receiptTotalSalesDelivery: [],
  receiptTotalPrice: [],
  receiptTotalPriceYear: [],
  receiptTotalPriceOnline: [],
  receiptTotalPriceDelivery: [],
  receiptPendingDeliveries: [],
  receiptMonthlySales: [],
  receiptMonthlyRevenue: [],
  receiptLastReceipt: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
      state.loading = false;
      state.success = false;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchUserList(state, action) {
      state.userList = action.payload;
      state.loading = false;
    },
    fetchUserFormList(state, action) {
      state.userFormList = action.payload;
      state.loading = false;
    },
    fetchUserDetail(state, action) {
      state.userDetail = action.payload;
      state.loading = false;
    },
    fetchReceiptList(state, action) {
      state.receiptList = action.payload;
      state.loading = false;
    },
    fetchReceiptDetail(state, action) {
      state.receiptDetail = action.payload;
      state.loading = false;
    },
    fetchTotalSalesDetail(state, action) {
      state.totalSalesDetail = action.payload;
      state.loading = false;
    },
    fetchReceiptTotalSales(state, action) {
      state.receiptTotalSales = action.payload;
      state.loading = false;
    },
    fetchReceiptTotalSalesYear(state, action) {
      state.receiptTotalSalesYear = action.payload;
      state.loading = false;
    },

    fetchReceiptTotalSalesOnline(state, action) {
      state.receiptTotalSalesOnline = action.payload;
      state.loading = false;
    },

    fetchReceiptTotalSalesDelivery(state, action) {
      state.receiptTotalSalesDelivery = action.payload;
      state.loading = false;
    },

    fetchReceiptTotalPrice(state, action) {
      state.receiptTotalPrice = action.payload;
      state.loading = false;
    },
    fetchReceiptTotalPriceYear(state, action) {
      state.receiptTotalPriceYear = action.payload;
      state.loading = false;
    },

    fetchReceiptTotalPriceOnline(state, action) {
      state.receiptTotalPriceOnline = action.payload;
      state.loading = false;
    },

    fetchReceiptTotalPriceDelivery(state, action) {
      state.receiptTotalPriceDelivery = action.payload;
      state.loading = false;
    },

    fetchReceiptPendingDeliveries(state, action) {
      state.receiptPendingDeliveries = action.payload;
      state.loading = false;
    },

    fetchReceiptMonthlySales(state, action) {
      state.receiptMonthlySales = action.payload;
      state.loading = false;
    },

    fetchReceiptMonthlyRevenue(state, action) {
      state.receiptMonthlyRevenue = action.payload;
      state.loading = false;
    },

    fetchReceiptLastReceipt(state, action) {
      state.receiptLastReceipt = action.payload;
      state.loading = false;
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice.reducer;
